<div class="rd-widget table-widget widget-two-columns-one-gap-fifty-percent widgetNoTopBorder widget-{{widgetConfig.widgetId}}" *ngIf="widgetData">
  <div class="table-part">
    <table class="widget-flex" style="height: 100%;" aria-hidden="true">
      <thead>
        <tr class="widget-ruller-flex">
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
        </tr>
        <tr>
          <th scope="col" colspan="16" class="widgetNoTopBorderShowCell darkGreyTableHeader">
            <widget-label [widget]="this" [fieldName]="'labelProperty'" [align]="'left'" [color]="'white'"></widget-label>            
          </th>
        </tr>
      </thead>
      <tbody *ngIf="editMode">
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelQualityOfTheBuilding'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.qualityOfTheBuildingid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"    
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.qualityOfTheBuildingComment= $event;"
            id="qualityOfTheBuildingComment" [(ngModel)]="widgetData.qualityOfTheBuildingComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelInteriorFittings'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.interiorFittingsid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"     
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.interiorFittingsComment= $event;"
            id="interiorFittingsComment" [(ngModel)]="widgetData.interiorFittingsComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelFlexibility'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.flexibilityid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"    
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.flexibilityComment= $event;"
            id="flexibilityComment" [(ngModel)]="widgetData.flexibilityComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelPropertyCondition'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.propertyConditionid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"     
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.propertyConditionComment= $event;"
            id="propertyConditionComment" [(ngModel)]="widgetData.propertyConditionComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelParking'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.parkingid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"     
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.parkingComment= $event;"
            id="parkingComment" [(ngModel)]="widgetData.parkingComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
        <tr>
          <th scope="col" colspan="16" class="widgetNoTopBorderShowCell darkGreyTableHeader">
            <widget-label [widget]="this" [fieldName]="'labelLocation'" [align]="'left'" [color]="'white'"></widget-label>
          </th>
        </tr>
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelMacroLocation'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.macroLocationid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"     
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.macroLocationComment= $event;"
            id="macroLocationComment" [(ngModel)]="widgetData.macroLocationComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelMicroLocation'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.microLocationid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"     
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.microLocationComment= $event;"
            id="microLocationComment1" [(ngModel)]="widgetData.microLocationComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelInfrastructure'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.infrastructureid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"     
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.infrastructureComment= $event;"
            id="infrastructureComment" [(ngModel)]="widgetData.infrastructureComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelAccessibility'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.accessibilityid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"     
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.accessibilityComment= $event;"
            id="accessibilityComment" [(ngModel)]="widgetData.accessibilityComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelCompetition'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.competitionid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"     
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.competitionComment= $event;"
            id="competitionComment" [(ngModel)]="widgetData.competitionComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="!editMode">
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelQualityOfTheBuilding'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.qualityOfTheBuildingid}} </widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.qualityOfTheBuildingComment}}</label> </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelInteriorFittings'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.interiorFittingsid}} </widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.interiorFittingsComment}}</label> </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelFlexibility'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.flexibilityid}} </widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.flexibilityComment}}</label> </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelPropertyCondition'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.propertyConditionid}} </widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.propertyConditionComment}}</label> </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelParking'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.parkingid}} </widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.parkingComment}}</label> </widget-value>
          </td>
        </tr>
        <tr>
          <th scope="col" colspan="16" class="widgetNoTopBorderShowCell darkGreyTableHeader">
            <widget-label [widget]="this" [fieldName]="'labelLocation'" [align]="'left'" [color]="'white'"></widget-label>
          </th>
        </tr>
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelMacroLocation'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.macroLocationid}} </widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.macroLocationComment}}</label> </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelMicroLocation'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.microLocationid}} </widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.microLocationComment}}</label> </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelInfrastructure'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.infrastructureid}} </widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.infrastructureComment}}</label> </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelAccessibility'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.accessibilityid}} </widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.accessibilityComment}}</label> </widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelCompetition'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.competitionid}} </widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.competitionComment}}</label> </widget-value>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="space-part">&nbsp;</div>

  <div class="table-part">
    <table class="widget-flex" style="height: 100%;" aria-hidden="true">
      <thead>
        <tr class="widget-ruller-flex">
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
        </tr>
        <tr>
          <th scope="col" colspan="16" class="widgetNoTopBorderShowCell darkGreyTableHeader">
            <widget-label [widget]="this" [fieldName]="'labelLiquidity'" [align]="'left'" [color]="'white'"></widget-label>
          </th>
        </tr>
      </thead>
      <tbody *ngIf="editMode">
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelWALT'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.waltid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"     
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.waltComment= $event;"
            id="waltComment" [(ngModel)]="widgetData.waltComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelOverUnderrent'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.overUnderRentid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"     
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.overUnderRentComment= $event;"
            id="overUnderRentComment" [(ngModel)]="widgetData.overUnderRentComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelQualityOfTenants'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.qualityOfTenantsid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"     
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.qualityOfTenantsComment= $event;"
            id="qualityOfTenantsComment" [(ngModel)]="widgetData.qualityOfTenantsComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelRentalGrowth'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.rentalGrowthid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"     
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.rentalGrowthComment= $event;"
            id="rentalGrowthComment" [(ngModel)]="widgetData.rentalGrowthComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelLettability'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.lettabilityid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"     
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.lettabilityComment= $event;"
            id="lettabilityComment" [(ngModel)]="widgetData.lettabilityComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
        <tr>
          <th scope="col" colspan="16" class="widgetNoTopBorderShowCell darkGreyTableHeader">
            <widget-label [widget]="this" [fieldName]="'labelMarket'" [align]="'left'" [color]="'white'"></widget-label>
          </th>
        </tr>
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelInvestmentMarket'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.investmentMarketid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"     
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.investmentMarketComment= $event;"
            id="investmentMarketComment" [(ngModel)]="widgetData.investmentMarketComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelInvestorType'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.investorTypeid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"     
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.investorTypeComment= $event;"
            id="investorTypeComment" [(ngModel)]="widgetData.investorTypeComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelInvestmentVolume'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.investmentVolumeid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"     
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.investmentVolumeComment= $event;"
            id="investmentVolumeComment" [(ngModel)]="widgetData.investmentVolumeComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelMarketability'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.marketabilityid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"     
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.marketabilityComment= $event;"
            id="marketabilityComment" [(ngModel)]="widgetData.marketabilityComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
        <tr>
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'labelSaleability'" [align]="'left'"></widget-label></td>
          <td colspan="2">
            <kendo-dropdownlist [data]="reflists['ref_l2_property_rating']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetData.saleabilityid"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="8" class="widget-label-right widget-h1">
            <input type="text"     
            hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
            [elType]="'text'" [page]="page"  
            [editMode]="editMode" 
            (setNewValue)="widgetData.saleabilityComment= $event;"
            id="saleabilityComment" [(ngModel)]="widgetData.saleabilityComment" class="widget-input-text widget-align-right gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="!editMode">
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelWALT'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.waltid}}</widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.waltComment}}</label></widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelOverUnderrent'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.overUnderRentid}}</widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.overUnderRentComment}}</label></widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelQualityOfTenants'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.qualityOfTenantsid}}</widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.qualityOfTenantsComment}}</label></widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelRentalGrowth'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.rentalGrowthid}}</widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.rentalGrowthComment}}</label></widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelLettability'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.lettabilityid}}</widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.lettabilityComment}}</label></widget-value>
          </td>
        </tr>
        <tr>
          <th scope="col" colspan="16" class="widgetNoTopBorderShowCell darkGreyTableHeader">
            <widget-label [widget]="this" [fieldName]="'labelMarket'" [align]="'left'" [color]="'white'"></widget-label>
          </th>
        </tr>
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelInvestmentMarket'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.investmentMarketid}}</widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.investmentMarketComment}}</label></widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelInvestorType'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.investorTypeid}}</widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.investorTypeComment}}</label></widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelInvestmentVolume'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.investmentVolumeid}}</widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.investmentVolumeComment}}</label></widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelMarketability'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.marketabilityid}}</widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.marketabilityComment}}</label></widget-value>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="widget-label-left">
            <widget-label [widget]="this" [fieldName]="'labelSaleability'" [align]="'left'"></widget-label>
          </td>
          <td colspan="1" class="widget-text-value widget-h1" style="text-align:center">
            <widget-value [align]="'center'">{{widgetData.saleabilityid}}</widget-value>
          </td>
          <td colspan="9" class="widget-text-value widget-h1 break-word" style="text-align: right">
            <widget-value [align]="'center'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.saleabilityComment}}</label></widget-value>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="footer-part">
    <span class="widget-h1 widget-gray-text">
      <widget-label [widget]="this" [fieldName]="'labelPoorAverageExcellent'" [align]="'left'"></widget-label>
    </span>
  </div>
</div>
